import { render, staticRenderFns } from "./HomeSecondaryCards.vue?vue&type=template&id=3bc8b295&scoped=true"
import script from "./HomeSecondaryCards.vue?vue&type=script&lang=js"
export * from "./HomeSecondaryCards.vue?vue&type=script&lang=js"
import style0 from "./HomeSecondaryCards.vue?vue&type=style&index=0&id=3bc8b295&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc8b295",
  null
  
)

export default component.exports